import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DeleteRecordingPrompt({
  onConfirm,
  onReject,
  hasVoicemail
}) {
  const LANG_KEY = hasVoicemail ? 'conversations-calling-message.timeline-call-metadata.call-voicemail.delete-recording' : 'conversations-calling-message.timeline-call-metadata.call-recording.delete-recording';
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_KEY}.title`
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${LANG_KEY}.body`
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        onClick: onConfirm,
        use: "danger",
        "data-selenium-test": "delete-recording-button",
        "data-test-id": "delete-recording-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_KEY}.confirm`
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onReject,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_KEY}.cancel`
        })
      })]
    })]
  });
}
DeleteRecordingPrompt.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  hasVoicemail: PropTypes.bool
};